import { render, staticRenderFns } from "./notes-convert-to-pdf.html?vue&type=template&id=bc5c1a6e&scoped=true&"
import script from "./notes-convert-to-pdf.js?vue&type=script&lang=js&"
export * from "./notes-convert-to-pdf.js?vue&type=script&lang=js&"
import style0 from "./notes-convert-to-pdf.scss?vue&type=style&index=0&id=bc5c1a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5c1a6e",
  null
  
)

export default component.exports